export { DataTable as default } from './DataTable';
export type { DataTableColumn, DataTableProps } from '@/types/components';

